var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionPurchasesOutlined({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 3a2 2 0 0 0-2 2v3H4v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8h-4V5a2 2 0 0 0-2-2h-4Zm4 5V5h-4v3h4Zm-8 2h12v9H6v-9Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionPurchasesOutlined);
export default __webpack_public_path__ + "static/media/ic_action_purchases_outlined.b179183656163dfaa889abb9be80f456.svg";
export { ForwardRef as ReactComponent };